import {Action} from '@ngrx/store';
import {LoginModel} from '../models/login-model';
import {ChangePasswordModel} from '../models/change-password-model';
import {CurrentUser} from '../models/current-user';
import { ErrorModel } from '../models/error-model';

export const LOGIN = '[Authentication] Login';
export const LOGIN_COMPLETE = '[Authentication] LoginComplete';
export const ALIAS_USER = '[Authentication] AliasUser';
export const ALIAS_USER_COMPLETE = '[Authentication] AliasUserComplete';
export const LOGOUT = '[Authentication] Logout';
export const LOGOUT_COMPLETE = '[Authentication] LogoutComplete';
export const RESET_PASSWORD = '[Authentication] ResetPassword';
export const RESET_PASSWORD_COMPLETE = '[Authentication] ResetPasswordComplete';
export const CHANGE_PASSWORD = '[Authentication] ChangePassword';
export const CHANGE_PASSWORD_COMPLETE = '[Authentication] ChangePasswordComplete';
export const SHOW_ERROR = '[Authentication] ShowError';
export const SHOW_SUCCESS = '[Authentication] ShowSuccess';
export const HIDE_MESSAGE = '[Authentication] HideMessage';
export const SET_UPLOAD_PROGRESS = '[Authentication] UploadProgress';

export class LoginAction implements Action {
  readonly type = LOGIN;

  constructor(public payload: LoginModel) {}
}

export class LoginCompleteAction implements Action {
  readonly type = LOGIN_COMPLETE;

  constructor(public payload: CurrentUser) {}
}

export class AliasUserAction implements Action {
  readonly type = ALIAS_USER;

  constructor(public payload: string) {}
}

export class AliasUserCompleteAction implements Action {
  readonly type = ALIAS_USER_COMPLETE;

  constructor(public payload: CurrentUser) {}
}

export class LogoutAction implements Action {
  readonly type = LOGOUT;
}

export class LogoutCompleteAction implements Action {
  readonly type = LOGOUT_COMPLETE;
}

export class ResetPasswordAction implements Action {
  readonly type = RESET_PASSWORD;

  constructor(public payload: string) {}
}

export class ResetPasswordCompleteAction implements Action {
  readonly type = RESET_PASSWORD_COMPLETE;

  constructor(public payload: boolean) {}
}

export class ChangePasswordAction implements Action {
  readonly type = CHANGE_PASSWORD;

  constructor(public payload: ChangePasswordModel) {}
}

export class ChangePasswordCompleteAction implements Action {
  readonly type = CHANGE_PASSWORD_COMPLETE;

  constructor(public payload: boolean) {}
}

export class ShowErrorAction implements Action {
  readonly type = SHOW_ERROR;

  constructor(public payload: string) {}
}

export class ShowSuccessAction implements Action {
  readonly type = SHOW_SUCCESS;

  constructor(public payload: string) {}
}

export class HideMessageAction implements Action {
  readonly type = HIDE_MESSAGE;
}

export class SetUploadProgressAction implements Action {
  readonly type = SET_UPLOAD_PROGRESS;

  constructor(public payload: number) {}
}

export class ErrorAction implements Action {
  readonly type = 'ERROR';

  constructor(public payload: ErrorModel) { }
}

export type Actions = LoginAction |
  LoginCompleteAction |
  AliasUserAction |
  AliasUserCompleteAction |
  LogoutAction |
  LogoutCompleteAction |
  ResetPasswordAction |
  ResetPasswordCompleteAction |
  ChangePasswordAction |
  ChangePasswordCompleteAction |
  ShowErrorAction |
  ShowSuccessAction |
  HideMessageAction |
  SetUploadProgressAction |
  ErrorAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/actions/authentication.ts